module.exports = __webpack_public_path__ + "img/sv2_2.fa8fcf1f.svg";